import {
  FaMobileAlt,
  FaBatteryHalf,
  FaChargingStation,
  FaCamera,
  FaMicrochip,
  FaTint,
  FaUnlockAlt,
  FaDatabase,
} from "react-icons/fa";

export const servicesData = [
  {
    slug: "screen-replacement",
    icon: <FaMobileAlt />,
    title: "Screen Replacement",
    shortDescription:
      "Broken, cracked, or damaged screens repaired with high-quality replacement parts.",

    description:
      "A cracked or damaged screen can make your phone difficult and uncomfortable to use. Our screen replacement service helps restore your device's display and touch functionality.",

    problems: [
      "Cracked or shattered screen",
      "Broken display",
      "Unresponsive touch screen",
      "Screen flickering or displaying lines",
      "Black or distorted display",
      "Damaged glass",
    ],

    benefits: [
      "Professional screen replacement",
      "Touch and display testing",
      "Careful device handling",
      "Quality replacement parts",
      "Complete functionality testing",
    ],
  },

  {
    slug: "battery-replacement",
    icon: <FaBatteryHalf />,
    title: "Battery Replacement",
    shortDescription:
      "Fast battery replacement for iPhone and Android devices with long-lasting performance.",

    description:
      "If your phone battery drains quickly, shuts down unexpectedly, or no longer holds a charge properly, a battery replacement may restore reliable everyday performance.",

    problems: [
      "Fast battery drainage",
      "Phone shutting down unexpectedly",
      "Battery not holding charge",
      "Slow charging caused by battery issues",
      "Swollen or damaged battery",
      "Poor battery performance",
    ],

    benefits: [
      "Battery health inspection",
      "Professional battery replacement",
      "Proper device testing",
      "Charging performance check",
      "Safe handling of the device",
    ],
  },

  {
    slug: "charging-port-repair",
    icon: <FaChargingStation />,
    title: "Charging Port Repair",
    shortDescription:
      "Fix charging issues, loose charging ports, and power connection problems.",

    description:
      "Charging problems can be caused by a damaged, loose, dirty, or faulty charging port. We diagnose the charging system and identify the source of the problem before carrying out the repair.",

    problems: [
      "Phone not charging",
      "Loose charging connection",
      "Charging cable disconnecting",
      "Slow or inconsistent charging",
      "Damaged charging port",
      "Charging connection problems",
    ],

    benefits: [
      "Charging port inspection",
      "Professional diagnosis",
      "Port cleaning when applicable",
      "Charging connection testing",
      "Complete charging functionality check",
    ],
  },

  {
    slug: "camera-repair",
    icon: <FaCamera />,
    title: "Camera Repair",
    shortDescription:
      "Front and rear camera repairs including focus, lens, and hardware issues.",

    description:
      "Camera problems can affect photos, videos, video calls, and other applications. Our camera repair service focuses on diagnosing camera hardware and related issues.",

    problems: [
      "Camera not opening",
      "Blurry photographs",
      "Camera not focusing",
      "Camera showing a black screen",
      "Damaged camera lens",
      "Front camera problems",
    ],

    benefits: [
      "Camera hardware inspection",
      "Front and rear camera testing",
      "Focus and image quality testing",
      "Lens inspection",
      "Complete camera functionality check",
    ],
  },

  {
    slug: "motherboard-repair",
    icon: <FaMicrochip />,
    title: "Motherboard Repair",
    shortDescription:
      "Advanced chip-level diagnostics and motherboard repairs for complex issues.",

    description:
      "Motherboard problems can cause serious device failures and may affect multiple functions of a phone. Our technicians diagnose motherboard-related faults and determine whether repair is possible.",

    problems: [
      "Phone not turning on",
      "Unexpected shutdowns",
      "Network-related hardware issues",
      "Short circuit problems",
      "Charging circuit problems",
      "Other complex hardware faults",
    ],

    benefits: [
      "Detailed motherboard diagnosis",
      "Component-level inspection",
      "Fault identification",
      "Careful repair process",
      "Post-repair functionality testing",
    ],
  },

  {
    slug: "water-damage-repair",
    icon: <FaTint />,
    title: "Water Damage Repair",
    shortDescription:
      "Professional cleaning and restoration for water-damaged devices.",

    description:
      "Liquid exposure can affect internal components and cause problems that appear immediately or later. Quick inspection and proper handling can help determine the condition of a water-damaged device.",

    problems: [
      "Phone exposed to water",
      "Device not turning on after liquid exposure",
      "Charging problems after water exposure",
      "Display problems",
      "Speaker or microphone issues",
      "Corrosion inside the device",
    ],

    benefits: [
      "Device inspection",
      "Internal component assessment",
      "Liquid damage diagnosis",
      "Cleaning where applicable",
      "Testing of affected functions",
    ],
  },

  {
    slug: "software-solutions",
    icon: <FaUnlockAlt />,
    title: "Software Solutions",
    shortDescription:
      "Software troubleshooting, updates, unlocking, flashing, and bug fixes.",

    description:
      "Software problems can cause slow performance, application crashes, boot issues, and other device problems. We diagnose software-related issues and provide appropriate solutions.",

    problems: [
      "Software errors",
      "Phone stuck on logo",
      "Application crashes",
      "System performance problems",
      "Software update issues",
      "Software-related bugs",
    ],

    benefits: [
      "Software diagnosis",
      "System troubleshooting",
      "Software updates",
      "Bug fixing",
      "Device functionality testing",
    ],
  },

  {
    slug: "data-recovery",
    icon: <FaDatabase />,
    title: "Data Recovery",
    shortDescription:
      "Recover important photos, videos, files, and device data safely.",

    description:
      "Losing important photos, videos, contacts, or files can be frustrating. Our data recovery service focuses on assessing the device and determining whether the required data can be recovered.",

    problems: [
      "Accidentally deleted files",
      "Lost photos and videos",
      "Device not turning on",
      "Data inaccessible after damage",
      "Storage-related problems",
      "Lost important files",
    ],

    benefits: [
      "Device and storage assessment",
      "Data recovery diagnosis",
      "Careful handling of storage",
      "Recovery of supported data",
      "Data verification where possible",
    ],
  },
];